import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { Techniques } from './repository';
import { Technique } from './entity';
import { type TechniqueData } from './dto';

export class TechniquesCommands
    implements Commands<Techniques, Technique, TechniqueData>
{
    addAll(repo: Techniques, data: TechniqueData[]): Techniques {
        repo.clear();
        data.forEach((techniqueData) => {
            this.add(repo, techniqueData);
        });
        return repo;
    }

    add(repo: Techniques, data: TechniqueData): Techniques {
        const technique = new Technique({
            id: data.id,
            name: data.name,
            label: data.label,
            description: data.description,
            url: data.url,
            srcId: data.srcId,
            assetTypeIds: data.techniqueAssetIds,
            isCustom: data.isCustom,
        });
        repo.add(technique);
        return repo;
    }

    update(repo: Techniques, entity: Technique): Technique {
        repo.update(entity);
        return entity;
    }

    remove(repo: Techniques, id: string): void {
        repo.remove(id);
    }

    create(repo: Techniques, data: Omit<TechniqueData, 'id'>): Technique {
        const uuid = new UUID();
        const technique = new Technique({
            id: uuid.toString(),
            name: data.name,
            label: data.label,
            description: data.description,
            url: data.url,
            srcId: data.srcId,
            assetTypeIds: data.techniqueAssetIds,
        });
        repo.add(technique);
        return technique;
    }

    fromJSON(entity: Technique[], changeCallback: () => void): Techniques {
        const newTechniques = new Techniques(changeCallback);
        entity.forEach((technique) => {
            newTechniques.add(
                new Technique({
                    id: technique.id,
                    name: technique.name,
                    label: technique.label,
                    description: technique.description,
                    url: technique.url,
                    srcId: technique.srcId,
                    assetTypeIds: technique.assetTypeIds,
                    isCustom: technique.isCustom,
                }),
            );
        });
        return newTechniques;
    }
}
